module.exports = __webpack_public_path__ + "static/img/CA@3x.501e54ab.jpg";